/*
 * @Descripttion: 路由配置
 * @version: 1.0.0
 * @Author: Jiang ShareFont
 * @Date: 2023-03-15 15:24:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-05-22 11:57:26
 */
import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Index from '@/components/index'
import ScreenDetail from '@/components/screen'
import DiySkin from '@/components/DiySkin'
import List from '@/components/list'
import Create from '@/components/create'
Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'index',
    component: Index
  },
  {
    path: '/screen',
    name: 'screen',
    component: ScreenDetail
  },
  {
    path: '/diy',
    name: 'diyskin',
    component: DiySkin
  },
  {
    path: '/list',
    name: 'List',
    component: List
  },
  {
    path: '/create',
    name: 'Create',
    component: Create
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js